/**
 * Clean SVG American flag — 13 stripes + 50 stars (9 rows: 6/5/6/5/6/5/6/5/6).
 * Aspect ratio 1.9:1 per US Flag Code.
 */
export const AmericanFlag = ({ className = "", waving = false, ariaHidden = false }) => {
  // Star positions on the union (canton) — 9 rows alternating 6 and 5 stars.
  const stars = [];
  const rows = [
    { count: 6, y: 0.0525, offset: 0 },
    { count: 5, y: 0.1050, offset: 0.5 },
    { count: 6, y: 0.1575, offset: 0 },
    { count: 5, y: 0.2100, offset: 0.5 },
    { count: 6, y: 0.2625, offset: 0 },
    { count: 5, y: 0.3150, offset: 0.5 },
    { count: 6, y: 0.3675, offset: 0 },
    { count: 5, y: 0.4200, offset: 0.5 },
    { count: 6, y: 0.4725, offset: 0 },
  ];
  const unionW = 0.76; // union spans 40% of width (0.76 units on 1.9 canvas)
  const unionH = 7 / 13; // union spans 7 stripes tall
  const stepX = unionW / 12;

  rows.forEach((row, ri) => {
    for (let i = 0; i < row.count; i++) {
      const x = stepX * (1 + row.offset * 2 + i * 2);
      stars.push({ cx: x, cy: row.y, key: `${ri}-${i}` });
    }
  });

  const stripeH = 1 / 13;
  return (
    <svg
      viewBox="0 0 1.9 1"
      className={`${className} ${waving ? "flag-wave" : ""}`}
      role={ariaHidden ? undefined : "img"}
      aria-label={ariaHidden ? undefined : "American flag"}
      aria-hidden={ariaHidden || undefined}
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Stripes — 13 total, top stripe red, alternating */}
      {[...Array(13)].map((_, i) => (
        <rect
          key={i}
          x="0"
          y={i * stripeH}
          width="1.9"
          height={stripeH}
          fill={i % 2 === 0 ? "#B4232E" : "#FFFFFF"}
        />
      ))}
      {/* Union / canton */}
      <rect x="0" y="0" width={unionW} height={unionH} fill="#17325F" />
      {/* Stars */}
      {stars.map((s) => (
        <Star key={s.key} cx={s.cx} cy={s.cy} r={0.0308} />
      ))}
    </svg>
  );
};

const Star = ({ cx, cy, r }) => {
  const points = [];
  for (let i = 0; i < 10; i++) {
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    const radius = i % 2 === 0 ? r : r * 0.4;
    const x = cx + Math.cos(angle) * radius;
    const y = cy + Math.sin(angle) * radius;
    points.push(`${x.toFixed(4)},${y.toFixed(4)}`);
  }
  return <polygon points={points.join(" ")} fill="#FFFFFF" />;
};
